import { GuardedDeletionService, GeneticMaterialService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  GeneticMaterialCreateDto,
  GeneticMaterialDto,
  GeneticMaterialExcelDownloadDto,
  GeneticMaterialUpdateDto,
} from '../proxy/general/dtos/genetic-material';
import { GENETICMATERIAL_CONFIG, GENETICMATERIAL_FIELDS } from './genetic-material.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-genetic-material',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, GeneticMaterialService, ConfirmationService],
  templateUrl: './genetic-material.html',
  styleUrl: './genetic-material.scss',
})
export class GeneticMaterial extends BaseCrudComponent<
  GeneticMaterialDto,
  GeneticMaterialCreateDto,
  GeneticMaterialUpdateDto,
  GeneticMaterialExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(GeneticMaterialService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('GeneticMaterial', ids),
  };
  config = GENETICMATERIAL_CONFIG;
  fields = GENETICMATERIAL_FIELDS;

  protected prepareUpdateDto(data: any, selected: GeneticMaterialDto): GeneticMaterialUpdateDto {
    return {
      name: data.name,
      geneticMaterialCrossingId: data.geneticMaterialCrossingId,
      notes: data.notes,
      isCommercialMaterial: data.isCommercialMaterial,
      isThirdParty: data.isThirdParty,
      remsoftName: data.remsoftName,
      sanitaryClassificationId: data.sanitaryClassificationId,
      geneticMaterialTypeId: data.geneticMaterialTypeId,
      geneticMaterialOriginId: data.geneticMaterialOriginId,
      speciesId: data.speciesId,
      geneticMaterialGroupId: data.geneticMaterialGroupId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'GeneticMaterial';
  }
}
